import { RouteRecordRaw } from 'vue-router'

import { REPORT_ROUTE_NAMES } from '@/modules/report/constants/ReportRouteNames'
import ReportLayout from '@/modules/report/layouts/ReportLayout.vue'
import ReportSales from '@/modules/report/pages/ReportSales.vue'
import ReportOverview from '@/modules/report/pages/ReportsOverview.vue'

import { UserGroup } from '@generated/types'

export const reportRoutes: RouteRecordRaw[] = [
  {
    path: '/venue/reports',
    component: ReportLayout,
    redirect: { name: REPORT_ROUTE_NAMES.OVERVIEW },
    meta: { usesCustomNavbar: true },
    children: [
      {
        path: 'overview',
        name: REPORT_ROUTE_NAMES.OVERVIEW,
        component: ReportOverview,
        meta: {
          pageTitle: 'Reports Overview',
        },
      },
      {
        path: 'sales',
        name: REPORT_ROUTE_NAMES.SALES,
        component: ReportSales,
        meta: {
          pageTitle: 'Sales Report',
        },
      },
      {
        path: 'downloads',
        name: REPORT_ROUTE_NAMES.DOWNLOADS,
        component: () => import('@/modules/report/pages/ReportDownloads.vue'),
        meta: {
          pageTitle: 'Report Downloads',
        },
      },
      {
        path: 'analytics',
        name: REPORT_ROUTE_NAMES.WEB_ANALYTICS,
        component: () => import('@/modules/mailchimp/pages/MarketingAnalytics.vue'),
        props: { hideMessage: true },
        meta: {
          pageTitle: 'Web Analytics',
          requiresAuth: UserGroup.OWNERS,
        },
      },
      {
        path: 'show-insights',
        name: REPORT_ROUTE_NAMES.SHOW_INSIGHTS,
        component: () => import('@/modules/show/pages/ShowInsights.vue'),
        meta: {
          pageTitle: 'Show Insights',
        },
      },
    ],
  },
]
